<template>
  <div>
    <div class="row">

      <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{msg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
        {{successMsg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="col-md-8">
        <button class="btn donation" v-on:click.stop.prevent="showAddDonation()">Adicionar doação manual</button>
        <button class="btn" v-on:click.stop.prevent="exportDonations()">Exportar para Planilha</button>
      </div>

      <div class="col-md-12 mt-4">
        <b>Obs: Doações recorrentes não são atualizadas. Consulte o extrato de doações na sessão "Extrato" ou na sua conta PayPal.</b>
      </div>

      <div class="col-md-12">
      <b-tabs class="donations-lists">
        <b-tab title="Doações Únicas">
          <table class="donations table" v-if="donations && donations.length > 0">
            <thead>
              <th>Data</th>
              <th>Valor</th>
              <th>Doador</th>
              <!-- <th>E-mail/Facebook Id</th> -->
              <th>Status</th>
              <th>Detalhes</th>
            </thead>
            <tbody>
              <tr v-for="d in donations" :key="d.DonationId">
                <td width="10%">{{getDate(d.timestamp)}}</td>
                <td width="10%">R$ {{d.value}} ({{d.paymentType}})</td>
                <td width="10%">{{d.fullname}} {{d.email ? '(' + d.email + ')' : ''}}</td>
                <!-- <td width="10%"></td> -->
                <td width="10%">{{getStatus(d.paymentStatus)}}</td>
                <td width="10%">
                  <a href="" v-on:click.stop.prevent="showDonationDetail(d)">Ver</a>
                  <a href="" v-if="d.manualDonation" @click.stop.prevent="deleteDonation(d)">| Excluir</a>
                </td>
              </tr>
            </tbody>
          </table>
          <h4 class="projects-empty" v-else>O projeto não recebeu doações.</h4>
        </b-tab>
        <b-tab title="Doações Recorrentes">
          <table class="donations table" v-if="donationsRecurrent && donationsRecurrent.length > 0">
            <thead>
              <th>Data</th>
              <th>Valor</th>
              <th>Doador</th>
              <!-- <th>Status</th> -->
              <th>Período</th>
              <th>Vencimento</th>
              <th>Detalhes</th>
            </thead>
            <tbody>
              <tr v-for="d in donationsRecurrent" v-bind:key="d.DonationId">
                <td>{{getDate(d.timestamp)}}</td>
                <td>R$ {{d.value}} ({{d.paymentType}})</td>
                <td width="10%">{{d.fullname}} {{d.email ? '(' + d.email + ')' : ''}}</td>
                <!-- <td>{{getStatus(d.paymentStatus)}}</td> -->
                <td>
                  <span :class="{'expired': checkIfMonthlyDonationExpired(d)}"
                  v-if="d.period">{{d.period}} meses {{checkIfMonthlyDonationExpired(d) ? '(Expirada)' : '' }}</span>
                </td>
                <td>{{ getDate(dueDate(d).getTime()) }}</td>
                <td>
                  <a href="" @click.stop.prevent="showDonationDetail(d)">Ver</a>
                  <a href="" v-if="d.manualDonation" @click.stop.prevent="deleteDonation(d)">| Excluir</a>
                </td>
              </tr>
            </tbody>
          </table>
          <h4 class="projects-empty" v-else>O projeto não recebe doações recorrentes.</h4>
        </b-tab>
      </b-tabs>
      </div>

    </div>

    <b-modal ref="donationDetail" hide-footer title="Detalhes da Doação">
      <div class="d-block text-center" v-if="donationModal">
        <p>Doador: {{donationModal.fullname}} ({{donationModal.email}})</p>
        <p>Valor: R$ {{convertToReal(donationModal.value)}}</p>
        <p v-if="donationModal.paymentMethod">Forma de pagamento: {{(donationModal.paymentMethod == 'credit_card') ? 'Cartão de Crédito' : 'Boleto'}}</p>
        <p>Tipo de Doação: {{(donationModal.type == 'single') ? 'Simples' : 'Recorrente'}}</p>
        <p v-if="donationModal.period">Período de Doação: {{donationModal.period}} meses</p>
        <p v-if="donationModal.paymentMethod">Plataforma de Pagamento: {{donationModal.paymentType}}</p>
        <p v-if="donationModal.type != 'monthly'">Status: {{getStatus(donationModal.paymentStatus)}}</p>
        <p class="expired" v-if="donationModal.type == 'monthly' && checkIfMonthlyDonationExpired(donationModal)">Doação Expirada!</p>
        <button v-if="donationModal.type == 'monthly' && checkIfMonthlyDonationExpired(donationModal)"
          class="btn btn-danger" @click.stop.prevent="openMail(donationModal)">Entrar em contato com Doador</button>
      </div>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Fechar</b-btn>
    </b-modal>

    <b-modal ref="addDonation" hide-footer title="Adicionar doação manual">
      <div v-if="showModalMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{msgModal}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form>
        <div class="form-group">
          <label>Valor da doação (*)</label>
          <input class="form-control" type="text" v-money="money" v-model="addDonationValue"/>
        </div>
        <div class="form-group">
          <label>Data da doação (*)</label>
          <input class="form-control" type="text" v-mask="mask" v-model="addDonationDate"/>
        </div>
        <div class="form-group">
          <label>Nome do doador (opcional)</label>
          <input class="form-control" type="text" v-model="addDonationName"/>
        </div>
        <div class="form-group">
          <label>E-mail do doador (opcional)</label>
          <input class="form-control" type="text" v-model="addDonationEmail"/>
        </div>
        <div class="form-group">
          <label>Mensagem (*)</label>
          <vue-editor v-model="addDonationMessage"></vue-editor>
        </div>
        <div class="form-checkbox">
          <input type="checkbox" v-model="addDonationHideValue" />
          Ocultar valor na página do projeto
        </div>
        <div class="form-checkbox">
          <input type="checkbox" v-model="addDonationHideUser" />
           Usar nome "Anônimo" na página do projeto
        </div>
      </form>
      <b-btn class="mt-3" variant="outline-success" block @click="saveDonation">Salvar</b-btn>
    </b-modal>

  </div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import { VueEditor } from 'vue2-editor'
import {VMoney} from 'v-money'
import {mask} from 'vue-the-mask'

export default {
  name: 'ProjectDonations',
  props: ['project'],
  components: {
    VueEditor
  },
  directives: {money: VMoney, mask: mask},
  data(){
    return {
      msg: '',
      successMsg: '',
      msgModal: '',
      showMsg: false,
      showSuccessMsg: false,
      showModalMsg: false,
      projectId: null,
      donations: null,
      donationsRecurrent: null,
      donationModal: null,
      addDonationValue: null,
      addDonationDate: null,
      addDonationName: null,
      addDonationEmail: null,
      addDonationMessage: null,
      addDonationHideValue: false,
      addDonationHideUser: false,
      page: 'donations',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      mask: 'XX/XX/XXXX'
    }
  },
  mounted(){
    this.projectId = this.project.ProjectId;
    if(this.project.Donations){
      this.donations = this.project.Donations.filter((d) => {
        return (d.type == 'single' || d.paymentStatus == 'paid') && (d.paymentType!= null || d.channel != null);
      });
      this.donationsRecurrent = this.project.Donations.filter((d) => {
        return d.type == 'monthly' && (d.paymentType!= null || d.channel != null) && d.paymentStatus != 'incomplete';
      })
      this.donations.sort(function(x, y){
        return y.timestamp - x.timestamp;
      })
      this.donations = this.donations.filter((d) => {
          return d.paymentStatus != 'incomplete';
        })
      this.donationsRecurrent.sort(function(x, y){
        return y.timestamp - x.timestamp;
      })
    }
  },
  methods: {
    getDate(timestamp){
      if(timestamp.toString().length < 11){
        timestamp = parseInt(timestamp.toString() + "000")
      }
      var date = new Date(parseInt(timestamp));
      return date.toLocaleDateString()
    },
    getTimeDifference(timestamp){
      return Functions.timeDifference(timestamp)
    },
    getStatus(status){
      switch(status){
        case 'incomplete':
          return 'Não Concluído';
          break;
        case 'waiting':
          return 'Aguardando Pagamento';
          break;
        case 'waiting_payment':
          return 'Aguardando Pagamento';
          break;
        case 'authorized':
          return 'Pago';
          break;
        case 'not_authorized':
          return 'Não Autorizado';
          break;
        case 'paid':
          return 'Pago';
          break;
      }
    },
    checkIfMonthlyDonationExpired(donation)
    {
      var date = this.dueDate(donation);
      var actualDate = new Date();
      if(actualDate.getTime() > date.getTime()){
        return true;
      }
      return false;
    },
    dueDate(donation)
    {
      var timestamp = donation.timestamp;
      if(timestamp.toString().length < 11){
        timestamp = parseInt(timestamp.toString() + "000")
      }
      var date = new Date(parseInt(timestamp));
      date.setMonth(date.getMonth() + donation.period);
      return date;
    },
    showDonationDetail(donation){
      this.donationModal = donation
      this.$refs.donationDetail.show()
    },
    showAddDonation(){
      this.$refs.addDonation.show()
    },
    hideModal(){
      this.$refs.donationDetail.hide()
      this.$refs.addDonation.hide()
    },
    saveDonation(){
      var r = confirm("Deseja realmente inserir a doação? Ela será contabilizada no total arrecadado.");
      if(r == true){
        this.$emit('showloading');
        if(this.validate()){
          this.hideModal();
          var value = (this.addDonationValue) ? parseFloat(this.addDonationValue.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;
          var date = this.addDonationDate.split('/');
          var timestamp = + new Date(date[2], date[1] - 1, date[0], 0, 0, 0);
          this.$http.post(API.Projects.updateProject + this.projectId,
          {page: 'manualDonation', value: value, timestamp: timestamp, name: this.addDonationName, email: this.addDonationEmail, message: this.addDonationMessage,
          anonymousValue: this.addDonationHideValue, anonymousUser: this.addDonationHideUser},
          {headers: auth.getHeaders()}).then((res) => {
            this.donations.push(res.body.donation);
            this.successMsg = res.body.message;
            this.showSuccessMsg = true;
            this.$emit('hideloading');
          }, (err) => {
            this.msg = err.body.message;
            this.showMsg = true;
            this.$emit('hideloading');
          })
        }else{
          this.$emit('hideloading');
        }
      }
    },
    validate(){
      if(!this.addDonationValue || this.addDonationValue == ''){
        this.msgModal = 'Deve inserir o valor da doação!';
        this.showModalMsg = true;
        return false;
      }
      if(!this.addDonationDate || this.addDonationDate == ''){
        this.msgModal = 'Deve inserir a data da doação!';
        this.showModalMsg = true;
        return false;
      }
      return true;
    },
    deleteDonation(donation){
      var r = confirm("Deseja realmente remover esta doação? Esta ação não terá mais volta.");
      if(r == true){
        this.$emit('showloading');
        this.$http.post(API.Projects.updateProject + this.projectId, {page: 'deleteDonation', donationId: donation.DonationId}, {headers: auth.getHeaders()})
        .then((res) => {
            this.successMsg = res.body.message;
            this.showSuccessMsg = true;
            this.donations = this.donations.filter((d) => {
              return d.DonationId !== donation.DonationId
            })
            this.$emit('hideloading');
        }, (err) => {
          this.msg = err.body.message;
          this.showMsg = true;
          this.$emit('hideloading');
        })
      }
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.msgModal = "";
      this.showModalMsg = false;
      this.showMsg = false;
      this.showSuccessMsg = false;
    },
    exportDonations(){
      let csvContent = "data:text/csv;charset=iso-8859-1,";
      var $this = this;
      csvContent += ['Data', 'Valor', 'Nome', 'E-mail', 'Canal', 'Status'].join(",") + "\r\n";
      this.donations.map((d) => {
        let arr = [$this.getDate(d.timestamp), $this.convertToReal(d.value), d.fullname, d.email, d.paymentType, $this.getStatus(d.paymentStatus)];
        let row = arr.join(",");
        csvContent += row + "\r\n";
      })
      var link = document.createElement('a');
      link.setAttribute('href', encodeURI(csvContent));
      link.setAttribute('download', this.project.slug + '.csv');
      link.click();
    },
    convertToReal(value){
      value = parseFloat(value)
      if(value){
        return Functions.numberToReal(value, false)
      }
      return value;
    },
    openMail(donation){
      if(donation.email){
        window.open("mailto:"+donation.email);
      }else{
        alert("Doador não forneceu um e-mail de contato.");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.alert{
  width: 100%;
}
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
.expired{
  color: red;
  font-weight: bold;
}
span{
  font-size: 15px;
}
.form-config{
    margin-top: 20px;
    .row{
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.donation{
        background-color: #fff;
        color: #00AE39;
        border-color: #00AE39;
      }
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.projects-empty{
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
  color: #333;
}
.donations-lists{
  margin-top: 20px;
}
.donations{
  width: 100%;
  display: table;
  thead{
    font-family: RalewayBold;
  }
  tbody{
    tr{
      font-family: RalewayRegular;
      a{
        text-decoration: none;
        color: #00AE39;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage-project/Donations.vue